/* eslint-disable import/no-extraneous-dependencies, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

import { schemaGenerator } from 'gatsby-core-theme/src/helpers/schema';
import { getUrl, getPageImage } from 'gatsby-core-theme/src/helpers/getters';
import keygen from 'gatsby-core-theme/src/helpers/keygen';

export function getLanguage(language) {
  if (language === 'no') return 'nb-NO';
  return language || 'en';
}
export function getCanonicalUrl(page) {
  if (page.canonical_url) {
    return `${process.env.GATSBY_SITE_URL}${page.canonical_url}`;
  }
  if (page.path === '/') {
    return process.env.GATSBY_SITE_URL;
  }
  return `${process.env.GATSBY_SITE_URL}${page.path}`;
}
export function getRobotOptions(options) {
  const array = [];
  if (!options.page_index) {
    array.push('noindex');
  } else {
    array.push('index');
  }
  if (!options.links_followed) {
    array.push('nofollow');
  } else {
    array.push('follow');
  }
  if (!options.images_index) {
    array.push('noimageindex');
  } else {
    array.push('max-snippet:-1,max-video-preview:-1');
  }
  if (!options.show_snippet) {
    array.push('nosnippet');
  } else {
    array.push('max-image-preview:large');
  }
  return array.join();
}
// TODO replace with page.category

const Head = ({ page = {}, siteInfo }) => {
  const sport = page?.relation?.sport?.name || 'soccer';
  const pageImage = getPageImage(page)
    ? getPageImage(page)
    : `${process.env.GATSBY_SITE_URL}images/logo-${sport}.webp`;

  return (
    <>
      <meta charSet="utf-8" />
      <title>{page.meta_title}</title>
      <html lang={getLanguage(page.language)} className={`${sport} ${page?.type}`} />
      <meta name="description" content={page.meta_description} />
      {page.robot_options && <meta name="robots" content={getRobotOptions(page.robot_options)} />}
      <link rel="canonical" href={getCanonicalUrl(page)} />
      {page.preconnect_links &&
        page.preconnect_links.map((link) => <link key={keygen()} rel="preconnect" href={link} />)}
      <meta name="og:title" content={page.meta_title} />
      <meta name="og:site_name" content={siteInfo?.site_name} />
      <meta name="og:description" content={page.meta_description} />
      <meta name="og:type" content="article" />
      <meta name="og:image" content={pageImage} />
      <meta name="og:url" content={getUrl(page.path)} />
      {schemaGenerator(page, pageImage).map(
        (schema) =>
          schema && (
            <script key={keygen()} type="application/ld+json">
              {`${schema}`}
            </script>
          )
      )}
    </>
  );
};

Head.propTypes = {
  siteInfo: PropTypes.shape({
    robots_txt: PropTypes.string,
    site_logo: PropTypes.string,
    site_name: PropTypes.string,
    gtm_id: PropTypes.string,
  }),
  page: PropTypes.shape({
    meta_title: PropTypes.string,
    language: PropTypes.string,
    meta_description: PropTypes.string,
    meta_robots: PropTypes.arrayOf(PropTypes.string),
    path: PropTypes.string,
    preconnect_links: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default Head;
